import axios from 'axios';
import { API_BASE_URL, handleApiError } from './_apiBase';

export interface BatteryType {
    id: number;
    name: string;
    label: string;
    is_coin_cell: boolean;
    voltage_max_mv: number;
    voltage_min_mv: number;
    /** [[mv, pct], ...] */
    curve_points: Array<[number, number]>;
}

export const fetchBatteryTypes = async (): Promise<BatteryType[]> => {
    try {
        const res = await axios.get(`${API_BASE_URL}/battery-types`);
        return res.data;
    } catch (error) { return handleApiError(error, 'Hämta batterityper'); }
};

export const createBatteryType = async (data: Omit<BatteryType, 'id'>): Promise<BatteryType> => {
    try {
        const res = await axios.post(`${API_BASE_URL}/battery-types`, data);
        return res.data;
    } catch (error) { return handleApiError(error, 'Skapa batterityp'); }
};

export const updateBatteryType = async (id: number, data: Partial<Omit<BatteryType, 'id'>>): Promise<any> => {
    try {
        const res = await axios.put(`${API_BASE_URL}/battery-types/${id}`, data);
        return res.data;
    } catch (error) { return handleApiError(error, 'Spara batterityp'); }
};

export const deleteBatteryType = async (id: number): Promise<any> => {
    try {
        const res = await axios.delete(`${API_BASE_URL}/battery-types/${id}`);
        return res.data;
    } catch (error) { return handleApiError(error, 'Ta bort batterityp'); }
};
